import script from "./Portfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./Portfolio.vue?vue&type=script&setup=true&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=66050a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66050a68"]])

export default __exports__